import React, {useEffect, useState} from 'react'
import {
    Avatar,
    Badge,
    Box,
    Button,
    Collapse,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from "@mui/material";
import {CheckBoxOutlineBlank, CheckBoxOutlined, Close, FilterAlt, Folder} from "@mui/icons-material";
import {msg} from "@lingui/macro";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {useLingui} from "@lingui/react";
import useMobile from "../../hooks/useMobile";
import * as lod from "lodash";
import httpReq from "../../services/httpReq";


const MapTagsButton = React.memo(({setTagValuesIds}) => {
    const isMobile = useMobile()
    const [isLoading, setIsLoading] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [selectedTagValues, setSelectedTagValues] = useState([])
    const [selectedTags, setSelectedTags] = useState([])
    const [reportTagList, setReportTagList] = useState([])
    const {_} = useLingui()

    const handleButtonClick = (event) => {
        setFiltersOpen(true)
    };

    const updateLoading = (tagIndex, tagValueIndex, isLoading) => {
        const newTags = [...reportTagList];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].isLoading = isLoading;
        newTags[tagIndex].values = tagValues;
        setReportTagList(newTags);
    }

    const updateLoaded = (tagIndex, tagValueIndex, isLoading) => {
        const newTags = [...reportTagList];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].isLoaded = isLoading;
        newTags[tagIndex].values = tagValues;
        setReportTagList(newTags);
    }

    const updateImage = (tagIndex, tagValueIndex, fileSrc) => {
        const newTags = [...reportTagList];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].fileSrc = fileSrc;
        newTags[tagIndex].values = tagValues;
        setReportTagList(newTags);
    }

    useEffect(() => {
        // Make the POST request to the server
        httpReq('/Tag/GetList', 'GET', null, true).then(res => {
            if (res.responseAnyError) return;
            const newTags = [...res.responseData].map((item) => {
                item.open = false;
                item.values = item.values.map((value) => {
                    value.isLoading = false;
                    value.isLoaded = false;
                    return value;
                });
                return item;
            });
            const v = [...lod.orderBy(newTags, ['orderIndex'], 'asc')]
            setReportTagList(v);
        });

    }, []);

    useEffect(() => {
        reportTagList.forEach((tag, tagIndex) => {
            const values = tag.values;
            values.forEach((value, tagValueIndex) => {
                if (value.isLoaded === false && value.isLoading === false && value.fileContent === '') {
                    updateLoading(tagIndex, tagValueIndex, true);
                    httpReq('/TagValue/Get/' + value.id, 'GET', null, true).then(res => {
                        if (res.responseAnyError) return;
                        const tagValue = res.responseData;
                        if (tagValue.fileContent) {
                            const fileSrc = "data:" + tagValue.fileMimeType + ";base64," + tagValue.fileContent;
                            updateImage(tagIndex, tagValueIndex, fileSrc);
                        }
                        updateLoading(tagIndex, tagValueIndex, false);
                        updateLoaded(tagIndex, tagValueIndex, true);
                    });

                }
            })
        })

    }, [reportTagList])

    const manageSelectedValues = (tag) => {
        const copyTags = [...selectedTags];
        const copyValues = [...selectedTagValues]
        const tagValues = tag.values
        const idx = copyTags.findIndex(t => t === tag.id)
        if (idx === -1) {
            copyTags.push(tag.id);
            //
            tagValues.forEach((value, index) => {
                const idx = copyValues.findIndex(t => t === value.id);
                if (idx === -1) {
                    copyValues.push(value.id)
                }
            })
            setSelectedTagValues(copyValues)
        } else {
            copyTags.splice(idx, 1)
            tagValues.forEach((value, index) => {
                const idx = copyValues.findIndex(t => t === value.id);
                if (idx > -1) {
                    copyValues.splice(idx, 1)
                }
            })
            setSelectedTagValues(copyValues)
        }
        setSelectedTags(copyTags)
    }


    const isInSelectedTags = (tag) => {
        const idx = selectedTags.findIndex(u => u === tag.id);
        return idx > -1
    }

    const isInSelectedTagValues = (value) => {
        const idx = selectedTagValues.findIndex(id => id === value.id);
        return idx > -1
    }

    const handleClose = () => setAnchorEl(null);

    const open = Boolean(anchorEl);
    const id = open ? 'community-button-popover' : undefined;

    return (
        <Box position="absolute" bottom="225px" right="9px">
            <IconButton
                aria-describedby={id}

                onClick={handleButtonClick}
                sx={{
                    backgroundColor: 'white',
                    borderRadius: 0,
                    width: 30,
                    height: 30,
                    boxShadow: 1,
                    border: '1px solid #ccc',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                    },
                }}
            >
                <Badge color={'secondary'} badgeContent={selectedTagValues.length}>
                    <FilterAlt style={{color: 'black'}}/>
                </Badge>
            </IconButton>
            <Drawer
                anchor="right"
                open={filtersOpen}
                onClose={() => setFiltersOpen(false)}
                PaperProps={{
                    sx: {
                        width: isMobile ? '100%' : 400,
                        p: 2,
                    },
                }}
                transitionDuration={300}
            >
                <Box>
                    <Box sx={{display: 'flex', alignItems: 'center', mb: 2}}>
                        <Typography
                            variant="h6"
                            sx={{flex: 1, textAlign: 'center', fontWeight: 600}}
                        >
                            {_(msg`Filter reports`)}
                        </Typography>
                        <IconButton onClick={() => setFiltersOpen(false)}>
                            <Close/>
                        </IconButton>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            mb: 3,
                            alignItems: 'center',
                        }}
                    >
                        <Button
                            sx={{flex: 1}}
                            variant="contained"
                            disabled={selectedTagValues.length === 0}
                            onClick={() => {
                                setTagValuesIds(selectedTagValues)
                                setFiltersOpen(false)
                            }}
                        >
                            Apply
                        </Button>
                        <Button
                            sx={{flex: 1}}
                            variant="contained"
                            disabled={selectedTagValues.length === 0}
                            onClick={() => {
                                setTagValuesIds([])
                                setSelectedTags([])
                                setSelectedTagValues([])
                            }}
                        >
                            Reset
                        </Button>
                    </Box>

                    <Divider sx={{mb: 2}}/>

                    <Typography variant="subtitle1" sx={{fontWeight: 600, mb: 1}}>
                        Tags
                    </Typography>

                    <List dense disablePadding>
                        {reportTagList.map((tag, idx) => (
                            <Box key={idx}>
                                <ListItem
                                    sx={{
                                        borderRadius: 2,
                                        bgcolor: 'grey.100',
                                        mb: 0.5,
                                        px: 2,
                                        py: 1,
                                        transition: '0.2s',
                                        '&:hover': {
                                            bgcolor: 'primary.light',
                                            color: 'primary.contrastText',
                                        },
                                    }}
                                >
                                    <ListItemIcon>
                                        <Avatar sx={{bgcolor: 'primary.main', width: 32, height: 32}}>
                                            <Folder fontSize="small" sx={{color: '#fff'}}/>
                                        </Avatar>
                                    </ListItemIcon>

                                    <ListItemText
                                        primary={tag.name}
                                        primaryTypographyProps={{
                                            fontWeight: 600,
                                            fontSize: '0.95rem',
                                        }}
                                    />

                                    <IconButton
                                        onClick={() => manageSelectedValues(tag)}
                                        sx={{
                                            ml: 'auto',
                                        }}
                                        size="small"
                                    >
                                        {isInSelectedTags(tag) ? <CheckBoxOutlined/> : <CheckBoxOutlineBlank/>}
                                    </IconButton>

                                    <IconButton
                                        onClick={() => {
                                            tag.open = !tag.open;
                                            const tags = [...reportTagList];
                                            tags[idx] = tag;
                                            setReportTagList(tags);
                                        }}
                                        size="small"
                                    >
                                        {tag.open ? <KeyboardArrowUpIcon fontSize="small"/> :
                                            <KeyboardArrowDownIcon fontSize="small"/>}
                                    </IconButton>
                                </ListItem>

                                <Collapse in={tag.open} unmountOnExit>
                                    <List dense sx={{pl: 6, maxHeight: 300, overflowY: 'auto', mb: 1}}>
                                        {tag.values?.length > 0 && !isLoading ? (
                                            tag.values.map((value, k) => (
                                                <ListItem
                                                    key={k}
                                                    sx={{
                                                        px: 1,
                                                        py: 0.5,
                                                        borderRadius: 1,
                                                        '&:hover': {
                                                            bgcolor: 'action.hover',
                                                        },
                                                    }}
                                                >
                                                    <ListItemIcon>
                                                        <Avatar
                                                            src={value.fileSrc}
                                                            alt={value.value}
                                                            sx={{
                                                                width: 28,
                                                                height: 28,
                                                                bgcolor: 'grey.200',
                                                            }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={value.value}
                                                        primaryTypographyProps={{
                                                            fontStyle: 'italic',
                                                            fontSize: '0.9rem',
                                                        }}
                                                    />
                                                    <IconButton
                                                        onClick={() => {
                                                            const copyTagValues = [...selectedTagValues];
                                                            const idx = copyTagValues.findIndex((v) => v === value.id);
                                                            if (idx === -1) {
                                                                copyTagValues.push(value.id);
                                                            } else {
                                                                copyTagValues.splice(idx, 1);
                                                            }
                                                            setSelectedTagValues(copyTagValues);
                                                        }}
                                                        size="small"
                                                    >
                                                        {isInSelectedTagValues(value) ? <CheckBoxOutlined/> :
                                                            <CheckBoxOutlineBlank/>}
                                                    </IconButton>
                                                </ListItem>
                                            ))
                                        ) : (
                                            <Typography
                                                sx={{
                                                    fontSize: '0.85rem',
                                                    textAlign: 'center',
                                                    mt: 1,
                                                    color: 'text.secondary',
                                                }}
                                            >
                                                {_(msg`Nessun tag trovato.`)}
                                            </Typography>
                                        )}
                                    </List>
                                </Collapse>
                            </Box>
                        ))}
                    </List>
                </Box>
            </Drawer>


        </Box>
    );
})
export default MapTagsButton;